import { relations, sql } from "drizzle-orm";
import { integer, jsonb, pgTable, primaryKey, real, text, timestamp, unique, uuid, varchar, } from "drizzle-orm/pg-core";
import { conversationTable } from "./conversation.js";
import { dataRequestTable, dataRequestUpdateTable } from "./dataRequest.js";
import { hdnLoanApplication } from "./hdn.js";
import { agency, appUser, version } from "./main.js";
import { workItem } from "./workItems.js";
export const dossier = pgTable("dossier", {
    name: varchar("name", { length: 255 }).notNull(),
    agencyId: uuid("agency_id")
        .references(() => agency.id, {
        onDelete: "cascade",
    })
        .notNull(),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    displayId: integer("display_id"),
    creationDate: timestamp("creation_date", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    lastOpened: timestamp("last_opened", {
        withTimezone: true,
        mode: "string",
    }),
    createdBy: uuid("created_by").references(() => appUser.id, {
        onDelete: "set null",
    }),
    dossierOwner: uuid("dossier_owner").references(() => appUser.id, {
        onDelete: "set null",
    }),
}, (t) => [unique("unique_display_id_agency").on(t.agencyId, t.displayId)]);
export const dossierRelations = relations(dossier, ({ one, many }) => ({
    agency: one(agency, {
        fields: [dossier.agencyId],
        references: [agency.id],
    }),
    dossierUser: many(dossierUser),
    versions: many(version),
    storedDocuments: many(dossierDocument),
    loanApplications: many(hdnLoanApplication),
    dataRequest: many(dataRequestTable),
    dataRequestUpdates: many(dataRequestUpdateTable),
    workItems: many(workItem),
    owner: one(appUser, {
        fields: [dossier.dossierOwner],
        references: [appUser.id],
    }),
    conversations: many(conversationTable),
}));
export const dossierUser = pgTable("dossier_user", {
    userId: uuid("user_id")
        .notNull()
        .references(() => appUser.id, { onDelete: "cascade" }),
    dossierId: uuid("dossier_id")
        .notNull()
        .references(() => dossier.id, { onDelete: "cascade" }),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
}, (table) => [
    primaryKey({
        name: "dossier_user_pkey",
        columns: [table.userId, table.dossierId],
    }),
]);
export const dossierUserRelations = relations(dossierUser, ({ one }) => ({
    appUser: one(appUser, {
        fields: [dossierUser.userId],
        references: [appUser.id],
    }),
    dossier: one(dossier, {
        fields: [dossierUser.dossierId],
        references: [dossier.id],
    }),
}));
export const dossierDocument = pgTable("dossier_document", {
    filename: text("filename").notNull(),
    contentType: text("content_type").notNull(),
    byteSize: integer("byte_size").notNull(),
    dossierId: uuid("dossier_id").references(() => dossier.id, {
        onDelete: "cascade",
    }),
    type: text("type")
        .notNull()
        .$type(),
    uploadedAt: timestamp("uploaded_at", {
        withTimezone: true,
        mode: "string",
    }).defaultNow(),
    agencyId: uuid("agency_id").references(() => agency.id, {
        onDelete: "set null",
    }),
    creationDate: timestamp("creation_date", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
});
export const storedDocumentRelations = relations(dossierDocument, ({ one, many }) => ({
    dossier: one(dossier, {
        fields: [dossierDocument.dossierId],
        references: [dossier.id],
    }),
    agency: one(agency, {
        fields: [dossierDocument.agencyId],
        references: [agency.id],
    }),
    conversation: one(conversationTable, {
        fields: [dossierDocument.id],
        references: [conversationTable.recordingId],
    }),
    classification: many(dossierDocumentClassification),
}));
export const dossierDocumentClassification = pgTable("dossier_document_classification", {
    documentId: uuid("document_id")
        .notNull()
        .references(() => dossierDocument.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    dossierId: uuid("dossier_id").references(() => dossier.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onUpdate: "cascade",
        onDelete: "cascade",
    }),
    label: text("label").notNull(),
    confidence: real("confidence").notNull(),
    pageCount: integer("page_count"),
    classifiedBy: text("classified_by").notNull(),
    extractionResult: jsonb("extraction_result"),
    classifiedAt: timestamp("classified_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
});
export const dossierDocumentClassificationRelations = relations(dossierDocumentClassification, ({ one }) => ({
    dossier: one(dossier, {
        fields: [dossierDocumentClassification.dossierId],
        references: [dossier.id],
    }),
    storedDocument: one(dossierDocument, {
        fields: [dossierDocumentClassification.documentId],
        references: [dossierDocument.id],
    }),
    agency: one(agency, {
        fields: [dossierDocumentClassification.agencyId],
        references: [agency.id],
    }),
}));
